import { render, staticRenderFns } from "./ChatSocket.vue?vue&type=template&id=72cb2a92"
import script from "./ChatSocket.vue?vue&type=script&lang=js"
export * from "./ChatSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports